const SvgDivide = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="M25.333 17.333H6.666v-2.667h18.667zm-6.666-8a2.667 2.667 0 1 1-5.334 0 2.667 2.667 0 0 1 5.334 0m0 13.334a2.667 2.667 0 1 1-5.334 0 2.667 2.667 0 0 1 5.334 0" />
  </svg>;
export default SvgDivide;